import React, { useState } from "react";
import { DatePicker, Form, Row, Select, Spin } from "antd";
import moment from "moment";
import { useDebouncedSearch } from "../../utils/Hooks";
import { useQuery } from "react-query";
import { AxiosAreasAPI } from "../Api";
import {
  DynamicCol,
  GutteredRow,
} from "../../common/components/AreasPositions/Grid";
import { find, get } from "lodash";

const ParentAreaEditForm = ({ form, area }) => {
  const [, debouncedSearch, setSearch] = useDebouncedSearch();
  const [isSearching, setIsSearching] = useState(true);

  const { Option } = Select;

  const parentLowerTimespan = get(
    find(
      area._links.parents,
      (p) => p.parent.code === get(area, "parent_info.code"),
    ),
    "timespan.lower",
  );

  const { data: areas } = useQuery(
    ["areas", debouncedSearch],
    () => AxiosAreasAPI.getAll({ search: debouncedSearch }, {}),
    { onSettled: () => setIsSearching(false) },
  );
  return (
    <Form layout={"vertical"} form={form}>
      <Row>
        <DynamicCol>
          <Form.Item
            label="Nova área pai:"
            name="parent_id"
            rules={[
              { required: true, message: "Por favor selecione uma área!" },
            ]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              onSearch={(value) => {
                setSearch(value);
                setIsSearching(true);
              }}
              notFoundContent={
                isSearching ? (
                  <Spin size={"small"} />
                ) : (
                  "Nenhuma área encontrada"
                )
              }
            >
              {!isSearching &&
                areas?.results
                  .filter((areaObject) => area.code !== areaObject.code)
                  .map((areaObject) => (
                    <Option key={areaObject.id} value={areaObject.id}>
                      {areaObject.name}
                    </Option>
                  ))}
            </Select>
          </Form.Item>
        </DynamicCol>
      </Row>
      <GutteredRow>
        <DynamicCol>
          <Form.Item
            label="Data de início da nova área pai"
            name="start_date"
            initialValue={
              parentLowerTimespan
                ? moment(new Date(parentLowerTimespan)).add(1, "day")
                : moment(new Date())
            }
            rules={[
              {
                required: true,
                message: "Por favor insira a data de início da nova área pai!",
              },
            ]}
          >
            <DatePicker
              placeholder={"Selecione uma data"}
              format={"DD/MM/YYYY"}
              disabledDate={(current) => {
                const endDate = form.getFieldValue("end_date");
                if (endDate) {
                  return current < endDate.startOf("day");
                }
                return (
                  current &&
                  parentLowerTimespan &&
                  current < parentLowerTimespan
                );
              }}
            />
          </Form.Item>
        </DynamicCol>
        <DynamicCol>
          <Form.Item
            label="Data de fim da área pai atual"
            name="end_date"
            hidden={!!!area.parent_info}
            rules={[
              {
                required: !!area.parent_info,
                message: "Por favor insira a data de fim da área pai atual!",
              },
              {
                validator: async (_, endDate) => {
                  let startDatetime = form.getFieldValue("start_date");

                  if (
                    endDate &&
                    startDatetime &&
                    endDate.startOf("day") > startDatetime.startOf("day")
                  ) {
                    return Promise.reject(
                      "A data de fim da área pai anterior deve ser menor que a data de inicio da nova área pai!",
                    );
                  }
                },
              },
            ]}
          >
            <DatePicker
              placeholder={"Selecione uma data"}
              format={"DD/MM/YYYY"}
              disabledDate={(current) => {
                return (
                  current &&
                  parentLowerTimespan &&
                  current < parentLowerTimespan.endOf("day")
                );
              }}
            />
          </Form.Item>
        </DynamicCol>
      </GutteredRow>
    </Form>
  );
};

export default ParentAreaEditForm;
